import { Box, Divider, Grid } from '@mui/material';
import { useAtomValue, useSetAtom } from 'jotai';
import ProductHitCard from '../products/common/ProductHitCard';
import { packagingSheetSelectedProductAtom } from '../state';
import { ProductCardData } from '../products/common/product-card.types';
import { DisplayMode } from '../search/state/state';
import WishlistContactButton from './WishlistContactButton';
import WishlistProductRow from './WishlistProductRow';
import { wishlistDisplayModeAtom } from './state';

interface WishlistProductListProps {
  products: ProductCardData[];
}

export default function WishlistProductList({ products }: WishlistProductListProps): React.JSX.Element {
  const displayMode = useAtomValue(wishlistDisplayModeAtom);
  const setSelectedProduct = useSetAtom(packagingSheetSelectedProductAtom);

  if (displayMode === DisplayMode.LIST) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 3,
          width: '100%',
          '& .MuiDivider-root:not(:last-child)': {
            display: 'block',
          },
          '& .MuiDivider-root:last-child': {
            display: 'none',
          },
        }}
      >
        {products.map((product) => (
          <>
            <WishlistProductRow product={product} key={product.id}/>
            <Divider />
          </>
        ))}
      </Box>
    );
  }

  return (
    <Grid container rowSpacing={2} columnSpacing={2}>
      {products.map((product) => (
        <Grid key={product.id} size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2.4 }}>
          <ProductHitCard
            product={product}
            onProductClick={() => setSelectedProduct(product)}
            displayCompany
            displaySuggestedRetailPrice
            displayWishlistButton
            actionButton={<WishlistContactButton supplierId={product.companyId} />}
          />
        </Grid>
      ))}
    </Grid>
  );
}
